module.exports={render:function (){var _vm=this;
  return _vm._c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._c('header', {
    class: {
      'hide-menu': this.hideMenu
    },
    attrs: {
      "id": "header"
    },
    on: {
      "click": function($event) {
        _vm.showMenu()
      }
    }
  }, [_vm._c('div', {
    staticClass: "header-bg"
  }), _vm._v(" "), _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._c('ul', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.updateFilterTag('')
      }
    }
  }, [_vm._c('li'), _vm._v(" "), _vm._c('li', {
    staticClass: "site-name"
  }, [_vm._c('div', {
    staticClass: "img-logo"
  }, [_vm._c('img', {
    attrs: {
      "src": require("./assets/tarot_sun.svg"),
      "alt": "",
      "width": "35"
    }
  })]), _vm._v(" "), _vm._c('h1', {
    attrs: {
      "id": "site-name"
    },
    on: {
      "mouseover": function($event) {
        _vm.colorFlash()
      },
      "mouseleave": function($event) {
        _vm.colorFlashNone()
      }
    }
  }, [_vm._v(" Parvulesco")])])])]), _vm._v(" "), _vm._v(" "), _vm._c('form', {
    attrs: {
      "id": "search"
    }
  }, [_vm._c('ul', [_vm._c('li', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.toggleSearchFilter()
      }
    }
  }, [_vm._c('div', {
    class: ['lines', {
      'is-active': this.isDisplayed
    }]
  })]), _vm._v(" "), _vm._c('li', {
    class: ['li-search', {
      'search-is-active': this.searchIsDisplayed
    }]
  }, [_vm._c('input', {
    staticClass: "input-search",
    attrs: {
      "id": "search-form",
      "placeholder": "Search",
      "name": "query",
      "type": "search",
      "autocomplete": "off",
      "required": ""
    },
    on: {
      "input": _vm.debounceInput,
      "keydown": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.enterSubmit($event)
      }
    }
  })]), _vm._v(" "), _vm._c('li', {
    staticClass: "search-cta",
    on: {
      "click": function($event) {
        _vm.toggleSearch()
      }
    }
  }, [_vm._c('label', {
    attrs: {
      "for": "search-form"
    }
  }, [_vm._c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "height": "512px",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "512px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_vm._c('path', {
    attrs: {
      "d": "M448.3,424.7L335,311.3c20.8-26,33.3-59.1,33.3-95.1c0-84.1-68.1-152.2-152-152.2c-84,0-152,68.2-152,152.2  s68.1,152.2,152,152.2c36.2,0,69.4-12.7,95.5-33.8L425,448L448.3,424.7z M120.1,312.6c-25.7-25.7-39.8-59.9-39.8-96.3  s14.2-70.6,39.8-96.3S180,80,216.3,80c36.3,0,70.5,14.2,96.2,39.9s39.8,59.9,39.8,96.3s-14.2,70.6-39.8,96.3  c-25.7,25.7-59.9,39.9-96.2,39.9C180,352.5,145.8,338.3,120.1,312.6z"
    }
  })])])]), _vm._v(" "), _vm._c('li', {
    staticClass: "about"
  }, [_vm._c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._c('span', [_vm._v("?")])])])])]), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    class: ['movies-ui', {
      'isShow': this.isDisplayed
    }]
  }, [_vm._c('ul', [_vm._c('li', {
    on: {
      "click": function($event) {
        _vm.sortBy('date')
      }
    }
  }, [_vm._v("Date")]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.sortBy('title_tmdb')
      }
    }
  }, [_vm._v("Title")]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Action')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Action'
        }
      }
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Horror')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Horror'
        }
      }
    }
  }, [_vm._c('span', [_vm._v("Horror")])])]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Mystery')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Mystery'
        }
      }
    }
  }, [_vm._c('span', [_vm._v("Mystery")])])]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Science-Fiction')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Science-Fiction'
        }
      }
    }
  }, [_vm._c('span', [_vm._v("Sci-Fi")])])]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Thriller')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Thriller'
        }
      }
    }
  }, [_vm._c('span', [_vm._v("Thriller")])])]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('Western')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'genre',
        params: {
          genre: 'Western'
        }
      }
    }
  }, [_vm._c('span', [_vm._v("Western")])])]), _vm._v(" "), _vm._c('li', {
    on: {
      "click": function($event) {
        _vm.updateFilterTag('')
      }
    }
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._c('span', [_vm._v("None")])])])])])]), _vm._v(" "), _vm._v(" "), _vm._c('router-view', {
    ref: "movies",
    attrs: {
      "keep-alive": "",
      "sortKey": this.sortKey,
      "sortOrders": this.sortOrders,
      "filterTag": this.filterTag,
      "filterKey": this.searchQuery
    }
  }), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    attrs: {
      "id": "footer"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92819ee6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 354
// module chunks = 2